exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper--1F2b4 {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.wrapper--1F2b4 .part--2qcLd {\n  padding-right: 5px;\n  font-weight: 400;\n  font-size: 16px;\n}\n\n.wrapper--1F2b4 .part--2qcLd::last-of-type {\n  padding-right: 0;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "wrapper--1F2b4",
	"part": "part--2qcLd"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/components/utils/CardNumber/CardNumber.m.scss
// module id = 1542
// module chunks = 0